import { gql } from "graphql-tag";

export default gql`
  mutation UnpinPrompt($promptId: Int!) {
    deleteResponse: delete_followed_prompt(prompt_id: $promptId) {
      success
    }
  }
`;

export interface UnpinPromptMutationData {
  deleteResponse: {
    success: boolean;
  };
}